/**
 * Chakra UI Text component styles
 */
const textStyles = {
  'display-xlarge': {
    fontSize: '40px',
    fontWeight: 'semibold',
    lineHeight: '140%',
  },
  'display-large': {
    fontSize: '28px',
    fontWeight: 'semibold',
    lineHeight: '140%',
  },
  'display-medium-bold': {
    fontSize: '26px',
    fontWeight: 'bold',
    lineHeight: '140%',
  },
  'display-medium': {
    fontSize: '26px',
    fontWeight: 'normal',
    lineHeight: '140%',
  },
  'display-small-semibold': {
    fontSize: '24px',
    fontWeight: 'semibold',
    lineHeight: '150%',
  },
  'display-small': {
    fontSize: '24px',
    fontWeight: 'normal',
    lineHeight: '150%',
  },
  heading: {
    fontSize: '20px',
    fontWeight: 'semibold',
    lineHeight: '150%',
  },
  subheading: {
    fontSize: '16px',
    fontWeight: 'semibold',
    lineHeight: '130%',
    textTransform: 'uppercase',
  },
  'button-semibold': {
    fontSize: '18px',
    fontWeight: 'semibold',
    lineHeight: '24px',
  },
  'button-regular': {
    fontSize: '18px',
    fontWeight: 'normal',
    lineHeight: '24px',
  },
  'body-regular': {
    fontSize: '18px',
    fontWeight: 'normal',
    lineHeight: '150%',
  },
  'body-bold': {
    fontSize: '18px',
    fontWeight: 'bold',
    lineHeight: '150%',
  },
  caption: {
    fontSize: '16px',
    fontWeight: 'normal',
    lineHeight: '150%',
  },
  'caption-bold': {
    fontSize: '16px',
    fontWeight: 'bold',
    lineHeight: '150%',
  },
  'xsmall-medium': {
    fontSize: '14px',
    fontWeight: 'medium',
    lineHeight: '150%',
  },
  xsmall: {
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: '150%',
  },
};

export default textStyles;
